/**
 * Stable CSS class names for E2E — Image search.
 */
export const IMGSEARCH = {
    page: 'image-search-page',
    breadcrumbSection: 'image-search-page__breadcrumb-section',
    loadingSection: 'image-search-page__loading-section',
    breadcrumbRow: 'image-search-page__breadcrumb-row',

    downloadOverlayDialogPaper: 'image-search-page__download-overlay-dialog',

    resultsToolbar: 'image-search-page__results-toolbar',
    labelSelectAllWrap: 'image-search-page__select-all-wrap',
    inputCheckboxSelectAll: 'image-search-page-input--checkbox-select-all',
    inputIconListView: 'image-search-page-input--icon-list-view',
    inputIconGridView: 'image-search-page-input--icon-grid-view',
    downloadWrap: 'image-search-page__download-wrap',

    resultsSummary: 'image-search-page__results-summary',
    notFoundHint: 'image-search-page__not-found-hint',

    gridImageList: 'image-search-page__grid-image-list',
    gridImageListItem: 'image-search-page__grid-image-item',
    gridImageOverlay: 'image-search-page__grid-image-overlay',
    gridProductImage: 'image-search-page__grid-product-image',
    inputCheckboxGridItem: 'image-search-page-input--checkbox-grid-item',

    emptyStateWrap: 'image-search-page__empty-state',
    searchPaperWrap: 'image-search-page__search-paper-wrap',
    searchPaper: 'image-search-page__search-paper',
    inputSearchCodes: 'image-search-page-input--text-search-codes',
    inputButtonSearch: 'image-search-page-input--button-search',
    batchSearchFormWrap: 'image-search-page__batch-search-wrap',
    inputButtonBatchSearch: 'image-search-page-input--button-batch-search',

    batchModalBody: 'image-search-batch-modal__body',
    inputTextareaBatchCodes: 'image-search-batch-modal-input--textarea-batch-codes',
    batchModalHintsRow: 'image-search-batch-modal__hints-row',

    productListPaper: 'image-search-product-list__paper',
    productListTable: 'image-search-product-list__table',
    productRowCheckbox: 'image-search-product-list-input--checkbox-row',
    productImageCell: 'image-search-product-list__image-cell',
} as const;

export const imgSearchCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
